import getOperation from "../../helpers/getOperation"

import AuthenticateAsOutputShape from "./AuthenticateAsOutputShape"
import AuthenticateOutputShape from "./AuthenticateOutputShape"
import CreateMyPersonalAccessTokenOutputShape from "./CreateMyPersonalAccessTokenOutputShape"
import IndexMyPersonalAccessTokensOutputShape from "./IndexMyPersonalAccessTokensOutputShape"
import RevokeMyPersonalAccessTokenOutputShape from "./RevokeMyPersonalAccessTokenOutputShape"
import StartTotpSetupOutputShape from "./StartTotpSetupOutputShape"

export {
  AuthenticateAsOutputShape,
  AuthenticateOutputShape,
  CreateMyPersonalAccessTokenOutputShape,
  IndexMyPersonalAccessTokensOutputShape,
  RevokeMyPersonalAccessTokenOutputShape,
  StartTotpSetupOutputShape
}

export const authenticateOperation = getOperation("identity/Authenticate")
export const authenticateAsOperation = getOperation("identity/AuthenticateAs")
export const changeMyIdentityEmailOperation = getOperation("identity/ChangeMyIdentityEmail")
export const confirmMyIdentityEmailOperation = getOperation("identity/ConfirmMyIdentityEmail")
export const createMyPersonalAccessTokenOperation = getOperation("identity/CreateMyPersonalAccessToken")
export const indexMyPersonalAccessTokensOperation = getOperation("identity/IndexMyPersonalAccessTokens")
export const revokeMyPersonalAccessTokenOperation = getOperation("identity/RevokeMyPersonalAccessToken")
export const startTotpSetupOperation = getOperation("identity/StartTotpSetup")
export const verifyTotpSetupOperation = getOperation("identity/VerifyTotpSetup")
